import { render, staticRenderFns } from "./Advogado.vue?vue&type=template&id=f4d96cbc&scoped=true"
import script from "./Advogado.vue?vue&type=script&lang=js"
export * from "./Advogado.vue?vue&type=script&lang=js"
import style0 from "./Advogado.vue?vue&type=style&index=0&id=f4d96cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d96cbc",
  null
  
)

export default component.exports